<div style="background-color: #C3D2FC4D; border-radius: 20px;">
  <div class="container">
    <div class="text-container">
      <p class="text-part">Trying to find the</p>
      <p class="text-highlight">SwiftChat app?</p>
    </div>
    <img src="../assets/swiftchat-logo.png" alt="SwiftChat Logo" class="logo">
    <div class="rating-container">
      <img src="../assets/Group.png" alt="Rating Icon" class="rating-icon">
      <div class="rating-details">
        <p class="rating-text">4.0 Rating</p>
        <img src="../assets/Frame.png" alt="Rating Frame" class="rating-frame">
      </div>
    </div>
    <a href="https://play.google.com/store/apps/details?id=ai.convegenius.app&hl=en_IN&pli=1" target="_blank" class="cta-button">
      Go to App
    </a>
  </div>
<div class="mb-xl-0 text-center text-md-start shadow-register p-3 bg-white corner-radius responsive-noShadow">
  <div>
    <div class="card-body px-2">
      <div class="mb-4 hidden-sm" style="padding: 0px 20px 0px 20px;">
        <h1 class="lh-1  register-header">Hello there! </h1>
        <h1 class="lh-1 register-header" style="font-size: 24px; font-weight: 500;">Welcome to Swiftchat
          Business Manager</h1>
      </div>
      <div class="row" style="width: 100%;font-size: 4px;">
        <div class="container text-center">
            <app-alert></app-alert>
        </div>
      </div>
      <form [formGroup]="registerForm" (ngSubmit)="onSubmit()" style="padding: 0px 20px 0px 20px;" class="x-axis-no-padding">
        <mat-form-field class="form-element col-12 col-md-12 mat-floating-label py-2">
          <input class="input-style" matInput placeholder="Name*" formControlName="name" />
          <mat-error
            *ngIf="registerForm.controls.name.invalid">
            Please enter Name
          </mat-error>
        </mat-form-field>

        <mat-form-field class="form-element col-12 col-md-12 mat-floating-label py-2">
          <input class="input-style" matInput placeholder="Email ID*" formControlName="email" />
          <mat-error
            *ngIf="
              !registerForm.controls['email'].valid &&
              registerForm.controls['email'].touched
            "
          >
            {{ getErrorEmail() }}
          </mat-error>
        </mat-form-field>

      <div class="form-element col-12 col-md-12 py-2 " style="font-family: Montserrat; display: flex; position: relative;">
          <label class="selected-option" (click)="toggleDropdown()">{{ selectedOption }}</label>
          <div class="dropdown-list" *ngIf="showDropdown">
            <div class="option" *ngFor="let option of dropdownOptions" (click)="selectOption(option)">{{ option }}</div>
          </div>
          <div (click)="toggleDropdown()">
            <img *ngIf="showDropdown === false" style="position: absolute; right: 3px; cursor: pointer; top: 5px; padding: 10px;" src="../assets/Vector-595.png">
            <img *ngIf="showDropdown" style="position: absolute; right: 3px; cursor: pointer; top: 5px; padding: 10px;" src="../assets/Vector-594.png">
          </div>
      </div>
      <div [formGroup]="registerForm" class="form-element col-12 col-md-12 pt-4" style="font-family: Montserrat;">
        <input formControlName="usage" class="input-style" [ngClass]="{
          'border-red': isMinLengthValid(),
          'border-default': !isMinLengthValid()
        }" matInput placeholder="Tell us briefly how you wish to use this platform"  />
        <label [ngClass]="{'text-red': isMinLengthValid()}" style="font-size: 8px;">Minimum 50 characters</label>
      </div>

        <mat-form-field class="form-element col-12 col-md-12 mat-floating-label py-2">
          <input  class="input-style" matInput placeholder="Password" [matTooltip]="registerForm.controls.password.value < 8  ? 'Your password needs to be at least 8 characters. one uppercase letter
          and one number ' : null"
          matTooltipPosition="above" type="password"
          formControlName="password" />

          <mat-error
            *ngIf="
              !registerForm.controls['password'].valid &&
              registerForm.controls['password'].touched
            "
          >
            {{ getErrorPassword() }}
          </mat-error>
        </mat-form-field>

        <mat-form-field class="form-element col-12 col-md-12 mat-floating-label py-2">
          <input  class="input-style" matInput placeholder="Confirm password" type="password" formControlName="confirmPassword" />
          <mat-error *ngIf="registerForm.get('confirmPassword').errors?.mustMatch">
            Password Dosen't matched
        </mat-error>
        <mat-error *ngIf="registerForm.hasError('required', 'confirmPassword')">
            confirm new password is required
        </mat-error>

        </mat-form-field>
        <section class="terms-section">
          <div class="mb-3">
            <!-- <input class="form-check-input" type="checkbox" formControlName="agree" [checked]="registerForm.value.agree" /> -->
            <label class="form-check-label mat-floating-label" style="font-family:'Montserrat' ;color: rgb(117, 117, 117);">By Clicking Register now, you agree to our <a (click)="goToLink('https://swiftchat.ai/securityandprivacy/swiftchat-user-terms-of-service/')" class="text-inherit fw-semi-bold" style="text-decoration:underline;cursor: pointer;">Terms</a>,
              <a  class="text-inherit fw-semi-bold" style="text-decoration:underline;cursor: pointer;" (click)="goToLink('https://swiftchat.ai/securityandprivacy/swiftchat-user-privacy-policy/')">Privacy Policy</a>  and 
              <a  class="text-inherit fw-semi-bold" style="text-decoration:underline;cursor: pointer;" (click)="goToLink('https://swiftchat.ai/securityandprivacy/swiftchat-cookie-policy/')"> Cookies Policy.</a></label>
          </div>
        </section>            
        <div class="d-flex justify-content-center mb-3">
          <button type="submit" [disabled]="!registerForm.valid" class="btn add btn-primary" style="width: 274px;border-radius: 80px;">Register Now</button>
        </div>
      </form>
      <div class="d-flex justify-content-center" style="padding: 0px 20px 0px 20px;font-size: 14px;">
      <p>Already have an account?<a routerLink="/signin" class="text-inherit fw-semi-bold" style="text-decoration:none ;">&nbsp;Log In</a>
      </p>
      </div>
    </div>
  </div>
</div>
</div>